
import { Prop, Component, Watch, Mixins, Emit } from "vue-property-decorator"
import DefinitionTitle from "../Config/Definitions/DefinitionTitle.vue"
import expressionValidation from "@/scripts/validation/expressionValidation"
import UtilsMixin from "@/mixins/utilsMixin.ts"

@Component({
	components: {
		"definition-title": DefinitionTitle
	}
})
export default class FieldExpression extends Mixins(UtilsMixin) {
	@Prop()
	public value!: string

	@Prop()
	fieldOptions!: any[]

	@Prop({ type: String, default: "Expression" })
	title!: string

	@Prop({ type: String, default: "Fields" })
	public fieldSelectPlaceholder!: string

	@Prop({ type: String, default: "calculation" })
	public fieldName!: string

	@Prop({ type: Boolean, default: true })
	public allowEmpty!: boolean

	@Prop({ type: Boolean, default: true })
	public requireFieldUsage!: boolean

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean

	@Watch("stateValid")
	private stateChanged (newState: boolean, oldState: boolean) {
		if (newState !== oldState) {
			this.$emit("stateChanged", newState)
		}
	}

	@Emit("input")
	private valueChanged (newValue: string): string {
		return newValue
	}

	@Emit("field-added")
	private expressionFieldAdded (fieldContainer: any): any {
		return fieldContainer
	}

	@Emit("field-removed")
	private expressionFieldRemoved (fieldContainer: any): any {
		return fieldContainer
	}

	private get expressionIsValid (): boolean {
		return expressionValidation.isValidMathExpression(this.value)
	}

	private get fieldsAreUsed (): boolean {
		return RegExp("{.+}").test(this.value ?? "")
	}

	private get expressionIsBlank (): boolean {
		return !this.value || this.value.trim().length === 0
	}

	private get stateValid (): boolean {
		return (this.expressionIsBlank && this.allowEmpty) || (
			!this.expressionIsBlank &&
			(this.fieldsAreUsed || !this.requireFieldUsage) &&
			this.expressionIsValid
		)
	}
}
